import styled from "styled-components";

import { getGridArea } from "./area.helpers";
import { keyArea } from "./area.types";
import type { Area, AreaComponent } from "./area.types";

export const area: Area = (Component, name) => {
  const componentName = Component.displayName || Component.name;
  const gridArea = getGridArea(name || componentName);

  const StyledComponent = styled(Component)`
    grid-area: ${gridArea};
  ` as unknown as AreaComponent;

  StyledComponent[keyArea] = gridArea;

  return StyledComponent;
};
